var map = {
	"./leveler-1-on.png": "21f9",
	"./leveler-2-on.png": "92be",
	"./leveler-3-on.png": "51a2",
	"./leveler-4-on.png": "d06d",
	"./leveler-5-on.png": "2e59",
	"./leveler-6-on.png": "259a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7c82";